export default {
    oauth: {
        url: 'https://oauth-abe.pixellot.tv',
        clientId: 'cms-internal',
        redirectUrl: 'https://vpum.pixellot.tv',
    },
};
